import { useState } from 'react';
import { Avatar as ChakraAvatar, AvatarProps as ChakraAvatarProps, forwardRef } from '@chakra-ui/react';
import Icon, { TypeIconName } from '../Icon/Icon';

export type AvatarSizes = '24' | '32' | '40' | '48' | '64' | '128';
export type AvatarVariant = 'user' | 'workspace' | 'brand' | 'letters' | 'project' | 'step';

export type AvatarProps = (
  | {
      iconName: TypeIconName;
      name?: never;
      size?: AvatarSizes;
      variant?: 'brand';
    }
  | {
      iconName?: never;
      name: string;
      size?: AvatarSizes;
      variant?: 'user' | 'workspace' | 'letters' | 'project' | 'step';
    }
) &
  ChakraAvatarProps;

const getInitials = (name: string) => {
  if (name.length < 3) {
    return name;
  }

  const nameArray = Array.from(name);

  return `${nameArray[0]}${nameArray[nameArray.length - 1]}`;
};

const Avatar = forwardRef<AvatarProps, 'span'>((props, ref) => {
  const { iconName, variant = 'user', size = '32', ...rest } = props;

  const [hasError, setError] = useState<boolean | undefined>(undefined);

  let icon;
  if (iconName) {
    icon = <Icon color="sys/neutral/strong" name={iconName} />;
  }

  const onError = () => {
    setError(true);
  };

  return (
    <ChakraAvatar
      getInitials={getInitials}
      icon={icon}
      onError={onError}
      size={size}
      variant={variant}
      background={hasError === false ? 'transparent' : undefined}
      {...rest}
      ref={ref}
    />
  );
});

export default Avatar;
